import React from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "redux";

import { ILocale } from "infrastructure/localization";

import { termDictionaryActions } from "../TermDictionary.actions";
import { useTermDictionaryColumnNames } from "../TermDictionary.hooks";
import { ITermDictionaryEntry, ITermDictionaryState, ITranslation } from "../TermDictionary.state";

import { TermDictionaryBilingualGrid } from "./TermDictionaryBilingualGrid";
import { TermDictionaryMonolingualGrid } from "./TermDictionaryMonolingualGrid";

export interface ITermDictionaryGridProps {
  locale?: ILocale;
  keyword?: string;
  bilingual?: boolean;
  entries?: ITermDictionaryEntry[] | ITranslation[];
  languageSelectionReversed?: boolean;
  selectionChanged: (termId: string) => void;
}

const TermDictionaryGrid: React.FC<ITermDictionaryGridProps> = ({ locale, keyword, bilingual, entries, languageSelectionReversed, selectionChanged }) => {
  const columnNames = useTermDictionaryColumnNames(locale, bilingual, languageSelectionReversed);

  return bilingual ? (
    <TermDictionaryBilingualGrid
      entries={entries as ITermDictionaryEntry[]}
      colNames={columnNames}
      keyword={keyword}
      onSelectionChanged={items => selectionChanged(items[0] ? items[0].term.termId : "")}
    />
  ) : (
    <TermDictionaryMonolingualGrid
      entries={entries as ITranslation[]}
      colName={columnNames[0]}
      keyword={keyword}
      onSelectionChanged={items => selectionChanged(items[0] ? items[0].termId : "")}
    />
  );
};

export default connect(
  (state: { termDictionary: ITermDictionaryState }) => {
    return {
      bilingual: state.termDictionary.searchQuery.bilingual,
      keyword: state.termDictionary.searchQuery.keyword,
      languageSelectionReversed: state.termDictionary.searchQuery.localeReversed,
      locale: state.termDictionary.searchQuery.locale,
      entries: state.termDictionary.searchResult
    };
  },
  (dispatch: Dispatch) => bindActionCreators({ selectionChanged: termDictionaryActions.toggleSelection }, dispatch)
)(TermDictionaryGrid);
